import React, { useCallback, useEffect, useState } from "react";
import {
  Button,
  Flex,
  Table,
  TableCaption,
  TableContainer,
  Tbody,
  Td,
  Tfoot,
  Th,
  Thead,
  Tr,
  Card,
  CardBody,
  CardHeader,
  Heading,
  useDisclosure,
  Text,
  Spacer,
  useBoolean,
  Input,
  Image,
  useToast,
} from "@chakra-ui/react";
import { AddIcon, DeleteIcon, EditIcon } from "@chakra-ui/icons";
import { ConfirmModal } from "../components";
import { AppAction, IKhuVucGiaDat } from "../_types_";
import { layDanhSachKhuVuc, themMoiKhuVuc } from "../apis/khu.vuc";
import { getToast } from "../utils";
import moment from "moment";
import { useGlobal } from "../contexts/Globals";

export default function KhuVucGiaDat() {
  const {isHasEditRole} = useGlobal();
  const { isOpen, onClose, onOpen } = useDisclosure();
  const [flag, setFlag] = useBoolean();
  const toast = useToast();

  const [KhuVucGiaDats, setKhuVucGiaDat] = useState<IKhuVucGiaDat[]>([]);

  const initData = useCallback(async (isHis = false) => {
    const mdResult = await layDanhSachKhuVuc(isHis);
    setKhuVucGiaDat(mdResult?.items || []);
  }, []);

  useEffect(() => {
    initData();
  }, []);

  const handleChange = (e: any, rndx: number, changingVariable: string) => {
    const value = {
      ...KhuVucGiaDats[rndx],
      [changingVariable]: e.target.value,
    };
    const arr = [...KhuVucGiaDats];
    arr[rndx] = value;
    setKhuVucGiaDat(arr);
  };

  const handleSaveChange = useCallback(
    async (model: IKhuVucGiaDat) => {
      try {
        const request = [model];
        await themMoiKhuVuc(request);
        toast(
          getToast(
            `${
              model.action === AppAction.DELETE
                ? "Xoá"
                : model.action === AppAction.EDIT
                ? "Sửa"
                : "Thêm"
            } khung giá đất thành công.`,
            "success",
            "Thông tin"
          )
        );
        await initData();
      } catch (er) {
        console.log("handleSaveClick", er);
      }
      setFlag.off();
    },
    [initData, setFlag, toast]
  );
  return (
    <Flex w="full" bg="whiteAlpha.900">
      <Card w="80%" margin="20px auto">
        <CardHeader>
          <Flex>
            <Heading as="h3" textTransform='uppercase'>Khu Vực Giá Đất</Heading>
            <Spacer />
        {isHasEditRole && <Button
              bg="green"
              size="sm"
              onClick={() => {
                const newKV: IKhuVucGiaDat = {
                  isDeleted: false,
                  createdDate: new Date(),
                  modifiedDate: new Date(),
                  createdUser: "0",
                  modifiedUser: "",
                  uuid: "",
                  id: 0,
                  khuVuc: "",
                  maKhuVuc: "",
                  moTa: "",
                  laLichSu: false,
                  action: AppAction.ADD,
                  hieuLuc: new Date(),
                  hetHieuLuc: new Date(),
                };
                setKhuVucGiaDat(KhuVucGiaDats.concat(newKV));
              }}
            >
              <AddIcon color="white" />
              <Text ml="10px" color="white">
                Thêm khu vực
              </Text>
            </Button>}
          </Flex>
        </CardHeader>
        <CardBody>
          <TableContainer w="full">
            <Table variant="simple">
              <Thead>
                <Tr>
                  <Th>Tên khu vực</Th>
                  <Th>Mã khu vực</Th>
                  <Th>#</Th>
                </Tr>
              </Thead>
              <Tbody>
                {KhuVucGiaDats.map((kv, rndx) => (
                  <Tr>
                    <Td>
                      <Input
                        type="text"
                        value={kv.khuVuc || ""}
                        defaultValue={kv.khuVuc || ""}
                        onChange={(t) => handleChange(t, rndx, "khuVuc")}
                      />
                    </Td>
                    <Td>
                      <Input
                        placeholder="Nhập mã KV"
                        value={kv.maKhuVuc || ""}
                        defaultValue={kv.maKhuVuc || ""}
                        onChange={(t) => handleChange(t, rndx, "maKhuVuc")}
                      />
                    </Td>

                    <Td paddingRight={"0px"}>
                      <Text color="gray.400">Hiệu lực</Text>
                    </Td>
                    <Td>
                      <Input
                        placeholder="Ngày hiệu lực"
                        size="md"
                        type="date"
                        value={
                          kv.hieuLuc
                            ? moment(kv.hieuLuc).format("YYYY-MM-DD")
                            : undefined
                        }
                        defaultValue={
                          kv.hieuLuc
                            ? moment(kv.hieuLuc).format("YYYY-MM-DD")
                            : undefined
                        }
                        onChange={(e) => {
                          handleChange(e, rndx, "hieuLuc");
                        }}
                        onKeyDown={(e) => {e.preventDefault();}}
                      />
                    </Td>
                    <Td paddingRight={"0px"}>
                      <Text color="gray.400">Hết hiệu lực</Text>
                    </Td>
                    <Td>
                      <Input
                        placeholder="Ngày hết hiệu lực"
                        size="md"
                        type="date"
                        value={
                          kv.hetHieuLuc
                            ? moment(kv.hetHieuLuc).format("YYYY-MM-DD")
                            : undefined
                        }
                        defaultValue={
                          kv.hetHieuLuc
                            ? moment(kv.hetHieuLuc).format("YYYY-MM-DD")
                            : undefined
                        }
                        onChange={(e) => {
                          handleChange(e, rndx, "hetHieuLuc");
                        }}
                        onKeyDown={(e) => {e.preventDefault();}}
                      />
                    </Td>

                {isHasEditRole &&   <Td>
                      <Button
                        disabled={kv.id == 0}
                        bg="red.300"
                        size="sm"
                        onClick={() => {
                          if (kv) {
                            kv.action = AppAction.DELETE;
                            handleSaveChange(kv);
                          }
                        }}
                      >
                        <DeleteIcon color="white" />
                      </Button>
                      <Button
                        bg="blue.300"
                        size="sm"
                        marginLeft="10px"
                        onClick={() => {
                          if (kv) {
                            kv.action =
                              kv.id > 0 ? AppAction.EDIT : AppAction.ADD;
                            handleSaveChange(kv);
                          }
                        }}
                      >
                        <Image src="./imgs/save.png" />
                      </Button>
                    </Td>}
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        </CardBody>
      </Card>
      <ConfirmModal isOpen={isOpen} onClose={onClose} onOk={onClose} />
    </Flex>
  );
}
